import SupplierInvoiceAccountingSection from './SupplierInvoiceAccountingSection';
import SupplierInvoiceAmountsSection from './SupplierInvoiceAmountsSection';
import SupplierInvoiceControlSection from './SupplierInvoiceControlSection';
import SupplierInvoicePreviewSection from './SupplierInvoicePreviewSection';
import SupplierInvoiceProviderSection from './SupplierInvoiceProviderSection';

const SupplierInvoiceActiveSection = ({
  activeSection,
  amountLines,
  amountTotals,
  currentAttachmentName,
  file,
  form,
  isEditMode,
  locksFinancialFields,
  movementConceptOptions,
  movementConceptsLoading,
  onAddAmountLine,
  onAmountLineChange,
  onChange,
  onFileChange,
  onRemoveAmountLine,
  providerOptions,
  selectedProviderName,
}) => {
  switch (activeSection) {
    case 'amounts':
      return (
        <SupplierInvoiceAmountsSection
          amountLines={amountLines}
          amountTotals={amountTotals}
          form={form}
          locksFinancialFields={locksFinancialFields}
          onAddAmountLine={onAddAmountLine}
          onAmountLineChange={onAmountLineChange}
          onChange={onChange}
          onRemoveAmountLine={onRemoveAmountLine}
        />
      );
    case 'accounting':
      return (
        <SupplierInvoiceAccountingSection
          form={form}
          movementConceptOptions={movementConceptOptions}
          movementConceptsLoading={movementConceptsLoading}
          onChange={onChange}
        />
      );
    case 'control':
      return (
        <SupplierInvoiceControlSection
          currentAttachmentName={currentAttachmentName}
          file={file}
          form={form}
          onChange={onChange}
          onFileChange={onFileChange}
        />
      );
    case 'preview':
      return (
        <SupplierInvoicePreviewSection
          amountLines={amountLines}
          amountTotals={amountTotals}
          currentAttachmentName={currentAttachmentName}
          file={file}
          form={form}
          providerName={selectedProviderName}
        />
      );
    case 'provider':
    default:
      return (
        <SupplierInvoiceProviderSection
          form={form}
          isEditMode={isEditMode}
          locksFinancialFields={locksFinancialFields}
          onChange={onChange}
          providerOptions={providerOptions}
        />
      );
  }
};

export default SupplierInvoiceActiveSection;
